module.exports = __webpack_public_path__ + "static/media/funitures3.b50106f9.svg";